<template>
  <component
    class="w-full flex items-center justify-between m-0"
    :class="[$style[variant]]"
    :is="component"
    v-on="$listeners"
  >
    <slot />
  </component>
</template>

<script>
import defaultRootComponent from '../defaultRootComponent'

/*
 * TODO: Switch to a typography once typrographical properties
 * are defined
 */

export default {
  name: 'SurfaceTitle',
  mixins: [ defaultRootComponent('div') ],
  props: {
    variant: {
      type: String,
      default: 'basic',
      validator: v => [
        'basic',
        'small',
      ].includes(v)
    }
  }
}

</script>

<style module>

  .basic {
		@apply
			p-4
      h-16
      font-medium
			text-base;
  }

  .small {
		@apply
			py-2
			px-4
      font-normal
      text-sm;
  }
</style>
